import React from 'react';
import Layout from '../components/Layout';
import ContactSection from '../components/ContactSection';
import '../styles/impressum-page.css';
import '../styles/page-layout.css';

const AffiliatePage: React.FC = () => {
  return (
    <Layout
      title="Empfehlungs-Programm | Stimm.DEV - 10% Provision für Weiterempfehlungen"
      description="Empfehlen Sie Stimm.DEV weiter und erhalten Sie 10% Provision! Einfach, ohne Links - jeder kann mitmachen und Geld verdienen."
      keywords="Empfehlung, Provision, Weiterempfehlung, 10 Prozent, Stimm.DEV, Berlin, App-Entwicklung, Website"
    >
      <section className="wrapper impressum-wrapper">
        <div className="page-container">
          {/* Header */}
          <div className="page-header">
            <span className="section-title">Partner-Programm</span>
            <h1>Professionelle Kooperationen</h1>
            <p>
              Werden Sie Kooperationspartner und profitieren Sie von attraktiven Vermittlungsprovisionen
            </p>
          </div>

          {/* Main Content */}
          <div className="page-content-card">
            
            {/* Hero Provision */}
            <div style={{ 
              background: 'linear-gradient(135deg, rgba(0, 158, 209, 0.2), rgba(0, 158, 209, 0.1))',
              padding: '3rem',
              borderRadius: '1rem',
              border: '1px solid rgba(0, 158, 209, 0.3)',
              textAlign: 'center',
              marginBottom: '3rem'
            }}>
              <h2 style={{ color: '#009ed1', marginTop: '0', marginBottom: '1rem', fontSize: '2.5rem', fontWeight: 'bold' }}>
                10% Provision
              </h2>
              <p style={{ fontSize: '1.2rem', color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0' }}>
                Als Kooperationspartner erhalten Sie eine attraktive Provision von 10% für jeden erfolgreich vermittelten Neukunden. Professionell und transparent.
              </p>
            </div>

            <h2 style={{ color: '#009ed1', marginTop: '0', marginBottom: '2rem', fontSize: '1.8rem' }}>
              Ablauf der Kooperation
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '1.5rem', 
              marginBottom: '3rem',
              justifyItems: 'center'
            }}>
              <div style={{
                background: 'rgba(0, 158, 209, 0.1)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.2)',
                textAlign: 'center',
                position: 'relative',
                minHeight: '200px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div style={{ fontSize: '2rem', marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9V7h9v14z"/>
                    </svg>
                  </div>
                  <div style={{ 
                    position: 'absolute', 
                    top: '1rem', 
                    right: '1rem', 
                    background: '#009ed1', 
                    color: 'white', 
                    borderRadius: '50%', 
                    width: '1.5rem', 
                    height: '1.5rem', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    fontSize: '0.8rem', 
                    fontWeight: 'bold' 
                  }}>1</div>
                  <h4 style={{ color: '#009ed1', marginBottom: '0.8rem', fontSize: '1rem' }}>
                    Kontaktvermittlung
                  </h4>
                </div>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.5', margin: '0', fontSize: '0.9rem' }}>
                  Sie vermitteln einen potenziellen Kunden an Stimm.DEV und stellen den ersten Kontakt her.
                </p>
              </div>
              
              <div style={{
                background: 'rgba(0, 158, 209, 0.1)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.2)',
                textAlign: 'center',
                position: 'relative',
                minHeight: '200px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div style={{ fontSize: '2rem', marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7H19V2h-2v2H7V2H5v2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V8h16v12z"/>
                    </svg>
                  </div>
                  <div style={{ 
                    position: 'absolute', 
                    top: '1rem', 
                    right: '1rem', 
                    background: '#009ed1', 
                    color: 'white', 
                    borderRadius: '50%', 
                    width: '1.5rem', 
                    height: '1.5rem', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    fontSize: '0.8rem', 
                    fontWeight: 'bold' 
                  }}>2</div>
                  <h4 style={{ color: '#009ed1', marginBottom: '0.8rem', fontSize: '1rem' }}>
                    Beratung & Angebot
                  </h4>
                </div>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.5', margin: '0', fontSize: '0.9rem' }}>
                  Wir führen eine professionelle Beratung durch und erstellen ein maßgeschneidertes Angebot.
                </p>
              </div>
              
              <div style={{
                background: 'rgba(0, 158, 209, 0.1)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.2)',
                textAlign: 'center',
                position: 'relative',
                minHeight: '200px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div style={{ fontSize: '2rem', marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                    </svg>
                  </div>
                  <div style={{ 
                    position: 'absolute', 
                    top: '1rem', 
                    right: '1rem', 
                    background: '#009ed1', 
                    color: 'white', 
                    borderRadius: '50%', 
                    width: '1.5rem', 
                    height: '1.5rem', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    fontSize: '0.8rem', 
                    fontWeight: 'bold' 
                  }}>3</div>
                  <h4 style={{ color: '#009ed1', marginBottom: '0.8rem', fontSize: '1rem' }}>
                    Provisionsauszahlung
                  </h4>
                </div>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.5', margin: '0', fontSize: '0.9rem' }}>
                  Bei Projektabschluss erhalten Sie umgehend Ihre 10% Provision auf den Nettoprojektwert.
                </p>
              </div>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Konditionen & Vergütung
            </h2>
            
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              border: '1px solid rgba(0, 158, 209, 0.2)',
              marginBottom: '3rem'
            }}>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '2rem'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                  </div>
                  <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                    Provisionssatz
                  </h4>
                  <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
                    10%
                  </p>
                  <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.8)', margin: '0' }}>
                    Auf den Nettoprojektwert
                  </p>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                  <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-5-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM3 13.97c0-.25.75-2.97 3-2.97s3 2.72 3 2.97V14H3v-.03z"/>
                    </svg>
                  </div>
                  <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                    Mindestprojektwert
                  </h4>
                  <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
                    1.000€
                  </p>
                  <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.8)', margin: '0' }}>
                    Für Provisionsanspruch
                  </p>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                  <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                    Auszahlung
                  </h4>
                  <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
                    14 Tage
                  </p>
                  <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.8)', margin: '0' }}>
                    Nach Projektabschluss
                  </p>
                </div>
              </div>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Kooperationspartner
            </h2>
            
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Professionelle Partner gesucht
            </h3>
            <ul style={{ lineHeight: '1.7', marginBottom: '2rem', color: 'rgba(255, 255, 255, 0.9)', paddingLeft: '1.5rem' }}>
              <li>Unternehmensberater und Consultants</li>
              <li>Marketingagenturen und Freelancer</li>
              <li>IT-Dienstleister und Systemhäuser</li>
              <li>Geschäftsführer und Entscheidungsträger</li>
              <li>Netzwerk-Partner aus der Digitalbranche</li>
            </ul>
            
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Zahlungskonditionen
            </h3>
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              border: '1px solid rgba(0, 158, 209, 0.2)',
              marginBottom: '2rem'
            }}>
              <ul style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', paddingLeft: '1.5rem', margin: '0' }}>
                <li><strong style={{ color: '#ffffff' }}>Provisionsauszahlung:</strong> 14 Tage nach Projektabschluss</li>
                <li><strong style={{ color: '#ffffff' }}>Mindestprovision:</strong> 100€ für Auszahlung</li>
                <li><strong style={{ color: '#ffffff' }}>Zahlungsarten:</strong> Banküberweisung oder PayPal</li>
                <li><strong style={{ color: '#ffffff' }}>Nachweis:</strong> Schriftliche Vermittlungsbestätigung</li>
                <li><strong style={{ color: '#ffffff' }}>Provision:</strong> 10% des Nettoprojektwertes (einmalig)</li>
              </ul>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Ihre Vorteile als Partner
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '1.5rem', 
              marginBottom: '3rem'
            }}>
              <div style={{
                background: 'rgba(0, 158, 209, 0.05)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.1)'
              }}>
                <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                  </svg>
                </div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Attraktive Vergütung
                </h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0', fontSize: '0.95rem' }}>
                  Erhalten Sie 10% Provision auf alle vermittelten Projekte ab 1.000€ Projektvolumen.
                </p>
              </div>
              
              <div style={{
                background: 'rgba(0, 158, 209, 0.05)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.1)'
              }}>
                <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                </div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Etablierte Marke
                </h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0', fontSize: '0.95rem' }}>
                  Profitieren Sie von unserem Ruf als vertrauensvoller Entwicklungspartner in Berlin.
                </p>
              </div>
              
              <div style={{
                background: 'rgba(0, 158, 209, 0.05)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.1)'
              }}>
                <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
                  </svg>
                </div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Unkomplizierte Abwicklung
                </h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0', fontSize: '0.95rem' }}>
                  Keine komplizierten Tracking-Systeme - einfache Vermittlung mit direkter Provision.
                </p>
              </div>
              
              <div style={{
                background: 'rgba(0, 158, 209, 0.05)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0, 158, 209, 0.1)'
              }}>
                <div style={{ marginBottom: '1rem', color: '#009ed1' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3z"/>
                  </svg>
                </div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Langfristige Partnerschaft
                </h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0', fontSize: '0.95rem' }}>
                  Bauen Sie eine dauerhafte Geschäftsbeziehung mit einem zuverlässigen Partner auf.
                </p>
              </div>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Partner werden
            </h2>
            
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              border: '1px solid rgba(0, 158, 209, 0.2)',
              textAlign: 'center'
            }}>
              <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.2rem' }}>
                Interesse an einer professionellen Kooperation?
              </h4>
              <p style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', marginBottom: '2rem' }}>
                Kontaktieren Sie uns für ein persönliches Gespräch über die Möglichkeiten einer Partnerschaft. Wir freuen uns auf eine erfolgreiche Zusammenarbeit.
              </p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '1rem', 
                flexWrap: 'wrap'
              }}>
                <a 
                  href="mailto:service@stimm.dev?subject=Partner-Programm%20-%20Interesse%20an%20Kooperation" 
                  style={{ 
                    border: '2px solid #009ed1',
                    color: '#ffffff',
                    background: 'transparent',
                    padding: '1rem 2rem',
                    borderRadius: '0.5rem',
                    textDecoration: 'none',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Partner werden
                </a>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div style={{
            maxWidth: '600px',
            margin: '3rem auto 4rem auto',
            textAlign: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, rgba(0, 158, 209, 0.1), rgba(0, 158, 209, 0.05))',
            borderRadius: '1rem',
            border: '1px solid rgba(0, 158, 209, 0.2)',
            backdropFilter: 'blur(10px)'
          }}>
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', margin: '0 0 1rem 0', padding: '0' }}>
              Fragen zum Partner-Programm?
            </h3>
            <p style={{ marginBottom: '1.5rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)' }}>
              Kontaktieren Sie uns gerne für weitere Informationen zu unserem Partner-Programm und den Kooperationsmöglichkeiten.
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '2rem', 
              flexWrap: 'wrap',
              fontSize: '0.9rem'
            }}>
              <a 
                href="mailto:service@stimm.dev" 
                style={{ 
                  color: '#009ed1', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                service@stimm.dev
              </a>
              <a 
                href="tel:+493042141523" 
                style={{ 
                  color: '#009ed1', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                +49 30 42141523
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <ContactSection />
    </Layout>
  );
};

export default AffiliatePage;
